import { Component } from 'react';
import { connect } from 'react-redux';

import Button from 'components/atoms/Button';
import Form from 'components/atoms/Form';
import FormGroup from 'components/atoms/FormGroup';
import Icon from 'components/atoms/Icon';
import InlineDateAndTimeSelect from 'components/atoms/InlineDateAndTimeSelect';
import Label from 'components/atoms/Label';
import { TIME_MODE_RANG_HOURS } from 'data/static';
import { bindActionCreators, Dispatch } from 'redux';
import { SetLayoutAction, setLayoutAction } from 'store/actions/layoutActions';
import { RootState } from 'types';
import { MapControlsInterface, MenuControlsInterface } from 'types/functions';
import { ActionsType, SystemType } from 'types/system';
import { DateTimeFormat } from 'utils/dateTimeFormat';
import { setKey } from 'utils/formHandlers';
import { translate } from 'utils/translate';

interface ChangeTimeModelProps {
    children?: string | JSX.Element | JSX.Element[];
    language: string;
    id?: string;
    data: any;
    system: SystemType;
    menuControls: MenuControlsInterface;
    mapControls: MapControlsInterface;
    actions: ActionsType | undefined;
    setLayoutAction: SetLayoutAction;
    dateTimeFormat: DateTimeFormat;
}

interface ChangeTimeModelState {
    errors: object;
    data: any | null;
}

class ChangeTimeModel extends Component<ChangeTimeModelProps, ChangeTimeModelState> {
    constructor(props: ChangeTimeModelProps) {
        super(props);
        this.state = {
            data: {
                live: props.dateTimeFormat.now().roundToNearest5Minutes(),
                time: props.menuControls?.time?.getDate()
                    ? props.menuControls?.time?.getDate()?.clone().plus({ hours: 1 })
                    : props.dateTimeFormat.now().roundToNearest5Minutes(),
            },
            errors: {},
        };
    }

    handleChange = (name: string, value: unknown) => {
        const { data, errors } = this.state;

        setKey(data, name, value);
        setKey(errors, name, null);
        this.setState({ data, errors });
    };

    handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault();
        this.props.actions?.onConfirm({
            startTime: this.state.data.time.clone().minus({ hours: TIME_MODE_RANG_HOURS }),
            endTime: this.state.data.time.clone(),
        });

        this.props.actions?.onCancel();
    };

    // handleFormLive = () => {
    //     this.props.menuControls.time?.changeDateRange(
    //         this.state.data.live.clone().minus({ hours: TIME_MODE_RANG_HOURS }),
    //         this.state.data.live.clone()
    //     );

    //     this.props.setLayoutAction([
    //         {
    //             action: 'UPDATE_MODE',
    //             data: {
    //                 section: 'time',
    //                 mode: 'live',
    //             },
    //         },
    //         {
    //             action: 'UPDATE_DATA',
    //             data: {
    //                 section: 'time',
    //                 data: {
    //                     startTime: this.state.data.live.clone().minus({ hours: TIME_MODE_RANG_HOURS }),
    //                     endTime: this.state.data.live.clone(),
    //                 },
    //             },
    //         },
    //         {
    //             action: 'UPDATE_SECTION',
    //             data: {
    //                 name: 'time',
    //                 state: true,
    //             },
    //         },
    //         {
    //             action: 'UPDATE_MENU',
    //             data: {
    //                 name: 'timeMenu',
    //                 section: 'time',
    //                 state: true,
    //             },
    //         },
    //     ]);

    //     this.props.actions?.onCancel();
    // };

    handleReset = () => {
        this.setState({
            ...this.state.data,
            data: { time: this.props.dateTimeFormat.now().roundToNearest5Minutes() },
        });
    };

    handleFormCancel = () => {
        this.props.actions?.onCancel();
    };

    render() {
        return (
            <>
                <Form onSubmit={this.handleFormSubmit} className="bg-white shadow p-4 w-full rounded">
                    <div id={`Drag-${this.props.id}`} className="flex justify-between mb-2 no-select ">
                        <div className="text-lg leading-6 font-bold">
                            {translate('display AIS data prior', { hours: TIME_MODE_RANG_HOURS })}
                        </div>
                        <div
                            onTouchEnd={this.handleFormCancel}
                            onClick={this.handleFormCancel}
                            className="cursor-pointer"
                        >
                            <Icon>
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M18 6l-12 12" />
                                <path d="M6 6l12 12" />
                            </Icon>
                        </div>
                    </div>
                    <div>
                        <FormGroup required={false}>
                            <Label>
                                {translate('Date and time')}:{' '}
                                <span className="text-gray-500 text-sm">{translate('Port local time zone')}</span>
                            </Label>
                            <InlineDateAndTimeSelect
                                onChange={this.handleChange}
                                name="time"
                                value={this.state.data.time}
                                today={this.props.system.date.today}
                                minDate={this.props.system.date.startDate}
                                maxDate={this.props.system.date.today}
                            ></InlineDateAndTimeSelect>
                        </FormGroup>
                    </div>

                    <div className="flex justify-end   ">
                        <div className="mt-5">
                            <Button
                                className="px-4 py-2 font-bold border border-gray-400"
                                onClick={this.handleFormCancel}
                            >
                                {translate('Cancel')}
                            </Button>
                            <Button
                                onClick={this.handleReset}
                                className="px-4 py-2 bg-yellow-100 mx-2 text-yellow-700 rounded-md"
                            >
                                {translate('Now')}
                            </Button>

                            <Button type="submit" className="px-4 py-2 bg-primary-submit rounded-md text-white">
                                {translate('Save')}
                            </Button>
                        </div>
                    </div>
                </Form>
            </>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    language: state.user.user.language,
    menuControls: state.layout.menuControls,
    system: state.port.system,
    mapControls: state.map.mapControls,
    dateTimeFormat: state.port.dateTimeFormat,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    setLayoutAction: bindActionCreators(setLayoutAction, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChangeTimeModel);
